import React from "react";
import './App.css';
import { HomePage } from './HomePage';

export const Home = (props) => {
  return (
    <div className="App">
      <HomePage user={props.user} />
    </div>
  );
};
